import { FilterOption } from "@coeff/api-admin-ext";
import React from "react";

import { FlexRow } from "../../../components";
import { CheckboxListPopover } from "../../../components/CheckboxListPopover";
import { ExportCSVButton } from "../../WorkspaceAdmin/ExportCSVButton";
import { TabName } from "../../WorkspaceAdmin/WorkspaceAdmin";
import { TableFilters } from "../useTableFilters";

import { DebouncedSearchInput } from "./DebouncedSearchInput";
import { DataSourceFilterPopover, UserFilterPopover } from "./FilterPopovers";

type Props = {
  domain: string;
  search: string;
  onSearchChange: (search: string) => void;
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
};

export const DomainDataSourcesFilterToolbar: React.FC<Props> = ({
  domain,
  onSearchChange,
  search,
  filters,
  setFilters,
}) => {
  const sharedFilterOptions: FilterOption[] = [
    {
      label: "Shared",
      value: "true",
    },
    {
      label: "Not Shared",
      value: "false",
    },
  ];

  const connectionStatusFilterOptions: FilterOption[] = [
    {
      label: "OK",
      value: "ok",
    },
    {
      label: "Error",
      value: "failed",
    },
  ];

  return (
    <FlexRow style={{ justifyContent: "space-between" }}>
      <DebouncedSearchInput initialSearch={search} onChange={onSearchChange} />

      <FlexRow>
        <DataSourceFilterPopover
          domain={domain}
          table="data_sources"
          values={filters.data_source_type}
          onChange={values =>
            setFilters({
              ...filters,
              data_source_type: values,
            })
          }
        />

        <CheckboxListPopover
          getLabel={() =>
            filters.is_shared === undefined ||
            filters.is_shared.length === 0 ||
            filters.is_shared.length === sharedFilterOptions.length
              ? "All Sharing"
              : filters.is_shared?.some(value => value === "false")
              ? "Not Shared"
              : "Shared"
          }
          initialValues={filters.is_shared}
          options={sharedFilterOptions}
          onChange={values =>
            setFilters({
              ...filters,
              is_shared: values,
            })
          }
          buttonProps={{
            className: "gray",
          }}
        />

        <CheckboxListPopover
          getLabel={() =>
            filters.status === undefined ||
            filters.status.length === 0 ||
            filters.status.length === connectionStatusFilterOptions.length
              ? "All Statuses"
              : filters.status?.some(value => value === "failed")
              ? "Status Error"
              : "Status OK"
          }
          initialValues={filters.status}
          options={connectionStatusFilterOptions}
          onChange={values =>
            setFilters({
              ...filters,
              status: values,
            })
          }
          buttonProps={{
            className: "gray",
          }}
        />

        <UserFilterPopover
          domain={domain}
          table="data_sources"
          values={filters.user_id}
          onChange={values =>
            setFilters({
              ...filters,
              user_id: values,
            })
          }
        />

        <ExportCSVButton tab={TabName.data_sources} />
      </FlexRow>
    </FlexRow>
  );
};
